export const enableBeforeUnload = (message: string) => {
    window.onbeforeunload = (e: BeforeUnloadEvent) => {
        e.preventDefault()
        e.returnValue = message
        return message
    }
}

export const disableBeforeUnload = () => {
    window.onbeforeunload = null
}
